import WidgetBox from "components/elements/WidgetBox/widget-box";
import {
  Flex,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  Checkbox,
  HStack,
  Th,
  Link,
} from "@chakra-ui/react";
import { useCustomFormats } from "hooks/useCustomFormat";
import React from "react";
import { StatusFilter } from "../status-filter";
import { ActionButton } from "../action-button";
import { ExportButton } from "../export-button";
import { ColumnsButton } from "../columns-button";
import { ThCheckbox } from "./components/th-checkbox";
import { ThSort } from "./components/th-sort";
import { TdActions } from "./components/td-actions";
import { ThActions } from "./components/th-actions";
import { Statement } from "../../types/statement";
import statements from "../../mocks/statements.json";
import { TdCheckbox } from "./components/td-checkbox";

export function StatementsTable() {
  const { formatDate } = useCustomFormats();
  const [selectedFrequency, setSelectedFrequency] = React.useState<string>("all");

  const SubTitle = () => (
    <Text fontWeight="normal" color="#6C6B6E" mt={-2}>
      View and manage your transaction statements and reports.
    </Text>
  );

  const TableFiltersAndActions = () => {
    const frequencies = [
      { value: "all", label: "All" },
      { value: "Daily", label: "Daily" },
      { value: "Monthly", label: "Monthly" },
      { value: "Quarterly", label: "Quarterly" },
      { value: "Yearly", label: "Yearly" },
    ];

    return (
      <Flex justifyContent="space-between" gap={2}>
        <StatusFilter
          statuses={frequencies}
          value={selectedFrequency}
          onChange={setSelectedFrequency}
        />
        <HStack gap={2}>
          <ColumnsButton />
          <ExportButton />
          <ActionButton />
        </HStack>
      </Flex>
    );
  };

  const DownloadLink = ({ url }: { url: string | undefined }) => {
    if (!url) return null;

    const fileName = url.split("/").pop();

    return (
      <Link href={url} target="_blank">
        <Text fontSize="sm" fontWeight="medium" color="#6200FF">
          {fileName}
        </Text>
      </Link>
    );
  };

  const TableData = () => {
    const filteredStatements = (statements as Statement[]).filter(
      statement => selectedFrequency === "all" || statement.frequency === selectedFrequency
    );

    return (
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <ThCheckbox />
              <ThSort>ID</ThSort>
              <ThSort>Created On</ThSort>
              <ThSort>Report Name</ThSort>
              <ThSort>Category</ThSort>
              <ThSort>Frequency</ThSort>
              <Th>Download</Th>
              <ThActions />
            </Tr>
          </Thead>
          <Tbody>
            {filteredStatements.map(statement => (
              <Tr key={statement.id}>
                <TdCheckbox />
                <Td>{statement.id}</Td>
                <Td>{formatDate(statement.createdOn)}</Td>
                <Td>{statement.reportName}</Td>
                <Td>{statement.category}</Td>
                <Td>{statement.frequency}</Td>
                <Td>
                  <DownloadLink url={statement.downloadLink} />
                </Td>
                <TdActions />
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <WidgetBox title="Statements">
      <Stack gap={6}>
        <SubTitle />
        <TableFiltersAndActions />
        <TableData />
      </Stack>
    </WidgetBox>
  );
}
